import {Loader} from "@/shared/ui";
import {Suspense} from "react";
import {Outlet} from "react-router-dom";

export const SuspenseSite = () => {
  return (
      <Suspense fallback={<Loader className={"h-screen"}/>}>
        <Outlet/>
      </Suspense>
  );
};

